(function () {
  var MOBILE_QUERY = '(max-width: 749px)';
  var OVERLAY_SELECTOR = '.kl-private-reset-css-Xuajs1, .needsclick';
  var OVERLAY_ATTR = 'data-bodf-klaviyo-overlay';
  var HIDE_ATTR = 'data-bodf-cart-dismissed';
  var observer;
  var scanFrame;

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  function isKlaviyoOverlay(element) {
    if (!(element instanceof HTMLElement)) return false;
    if (!element.className || String(element.className).indexOf('kl-private-reset-css') === -1) return false;

    var style = window.getComputedStyle(element);
    if (style.position !== 'fixed') return false;

    var zIndex = parseInt(style.zIndex || '0', 10);
    if (Number.isNaN(zIndex) || zIndex < 10000) return false;

    var rect = element.getBoundingClientRect();
    return rect.width >= window.innerWidth * 0.85 && rect.height >= window.innerHeight * 0.85;
  }

  function markKlaviyoOverlays() {
    if (!isMobile()) return;

    var overlays = [];
    document.querySelectorAll(OVERLAY_SELECTOR).forEach(function (element) {
      if (element.getAttribute(OVERLAY_ATTR) === 'true') return;
      if (isKlaviyoOverlay(element)) overlays.push(element);
    });

    overlays.forEach(function (element) {
      element.setAttribute(OVERLAY_ATTR, 'true');
    });
  }

  function scheduleOverlayScan() {
    if (scanFrame || !isMobile()) return;

    scanFrame = window.requestAnimationFrame(function () {
      scanFrame = null;
      markKlaviyoOverlays();
    });
  }

  function containsOverlayCandidate(node) {
    if (!(node instanceof Element)) return false;
    return node.matches(OVERLAY_SELECTOR) || Boolean(node.querySelector(OVERLAY_SELECTOR));
  }

  function handleMutations(mutations) {
    if (!isMobile()) return;

    for (var index = 0; index < mutations.length; index += 1) {
      var mutation = mutations[index];
      var target = mutation.target;
      if (target instanceof Element && (target.matches(OVERLAY_SELECTOR) || target.closest(OVERLAY_SELECTOR))) {
        scheduleOverlayScan();
        return;
      }

      var addedNodes = mutation.addedNodes;
      for (var nodeIndex = 0; nodeIndex < addedNodes.length; nodeIndex += 1) {
        if (containsOverlayCandidate(addedNodes[nodeIndex])) {
          scheduleOverlayScan();
          return;
        }
      }
    }
  }

  function dismissKlaviyoOverlays() {
    document.querySelectorAll('[' + OVERLAY_ATTR + '="true"]').forEach(function (element) {
      if (element instanceof HTMLElement) {
        element.setAttribute(HIDE_ATTR, 'true');
        element.style.setProperty('display', 'none', 'important');
        element.style.setProperty('pointer-events', 'none', 'important');
      }
    });
  }

  function isCartActionTarget(target) {
    if (!(target instanceof Element)) return false;

    return Boolean(
      target.closest('product-form-component') ||
        target.closest('add-to-cart-component') ||
        target.closest('.add-to-cart-button') ||
        target.closest('[name="add"]') ||
        target.closest('cart-drawer-component') ||
        target.closest('.cart-drawer')
    );
  }

  function handleCartIntent(event) {
    if (!isMobile()) return;

    markKlaviyoOverlays();

    if (isCartActionTarget(event.target)) {
      dismissKlaviyoOverlays();
    }
  }

  function startGuard() {
    document.addEventListener('pointerdown', handleCartIntent, true);
    document.addEventListener('submit', handleCartIntent, true);
    document.addEventListener('cart:update', dismissKlaviyoOverlays);

    markKlaviyoOverlays();
    window.addEventListener('load', scheduleOverlayScan);

    if (!observer && document.documentElement) {
      observer = new MutationObserver(handleMutations);
      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startGuard, { once: true });
  } else {
    startGuard();
  }
})();
